/**
 * Telefone BR vindo do backend → forma local, para exibir e editar.
 *
 * O cadastro guarda o telefone em formatos diferentes conforme a origem (app,
 * importação, PDV): uns só com DDD + número, outros com o código do país. Jogar
 * o valor cru na máscara `phone` da lib produz lixo, porque ela corta em 11
 * dígitos: "5511999998888" virava "(55) 11999-9988" — DDD errado, número
 * truncado e, de quebra, reprovado pelo `isValidPhone` (o 3º dígito deixa de ser
 * 9), então a pessoa via um telefone que não é o dela E um erro de validação.
 *
 * A formatação em si continua sendo da lib (`applyMask`); aqui só se resolve o
 * código do país, que ela não tem como conhecer.
 */

// Subpath `/utils`: helpers puros, SEM a diretiva 'use client' do barrel — este
// módulo é alcançado a partir de Server Components.
import { applyMask, removeNonNumbers } from "@dionatanbig2be/big2be-ui/utils";

/**
 * Dígitos do telefone sem o código do país: `DDD + número` (10 ou 11 dígitos).
 *
 * O "55" só é removido em 12 ou 13 dígitos (55 + fixo, 55 + celular). Nos
 * tamanhos locais ele é mantido de propósito: **55 também é DDD válido** (Santa
 * Maria/RS), então "5533334444" é um fixo legítimo, não um número com país.
 */
export function toLocalBrPhoneDigits(value: string | null | undefined): string {
    const digits = removeNonNumbers(value ?? "");
    const hasCountryCode =
        (digits.length === 12 || digits.length === 13) && digits.startsWith("55");

    return hasCountryCode ? digits.slice(2) : digits;
}

/** Telefone BR pronto para o campo: `(11) 99999-8888`. Vazio quando não há número. */
export function formatBrPhone(value: string | null | undefined): string {
    return applyMask("phone", toLocalBrPhoneDigits(value));
}
